import { today, daysAgo } from "@shared/utils/date";
import { useDateRange } from "@shared/hooks/useDateRange";

export function DateRangeFilter() {
  const { range, setRange, clear } = useDateRange();

  return (
    <div className="date-range-filter">
      <div className="date-range-fields">
        <label className="date-range-label">
          Desde
          <input
            type="date"
            value={range.from}
            onChange={(e) => setRange({ from: e.target.value, to: range.to })}
          />
        </label>
        <label className="date-range-label">
          Hasta
          <input
            type="date"
            value={range.to}
            onChange={(e) => setRange({ from: range.from, to: e.target.value })}
          />
        </label>
      </div>
      <div className="date-range-actions">
        <button
          type="button"
          className="btn btn-sm btn-secondary"
          onClick={() => setRange({ from: today(), to: today() })}
        >
          Hoy
        </button>
        <button
          type="button"
          className="btn btn-sm btn-secondary"
          onClick={() => setRange({ from: daysAgo(7), to: today() })}
        >
          7 días
        </button>
        <button
          type="button"
          className="btn btn-sm btn-secondary"
          onClick={() => setRange({ from: daysAgo(30), to: today() })}
        >
          30 días
        </button>
        <button
          type="button"
          className="btn btn-sm btn-secondary"
          onClick={clear}
          disabled={!range.from && !range.to}
        >
          Todo
        </button>
      </div>
    </div>
  );
}
